module.exports = __webpack_public_path__ + "static/media/logo_mec.6db3c30b.png";